var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FF6C37;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.6,39.6c0-1.5,1.2-2.7,2.7-2.7h42.8c1.5,0,2.7,1.2,2.7,2.7s-1.2,2.7-2.7,2.7H24.4 C22.8,42.3,21.6,41.1,21.6,39.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.5,55c0-1.5,1.2-2.7,2.7-2.7h42.8c1.5,0,2.7,1.2,2.7,2.7c0,1.5-1.2,2.7-2.7,2.7H24.2 C22.7,57.7,21.5,56.5,21.5,55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.5,70.5c0-1.5,1.2-2.7,2.7-2.7h17.1c1.5,0,2.7,1.2,2.7,2.7c0,1.5-1.2,2.7-2.7,2.7H24.2 C22.7,73.2,21.5,72,21.5,70.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.6,2.3h5.5v10.2c0,2,0,3.3,0.1,4.3c0.1,1,0.2,1.4,0.4,1.7c0.4,0.8,1,1.4,1.8,1.8c0.3,0.1,0.7,0.3,1.7,0.4 c1,0.1,2.3,0.1,4.3,0.1h11.2v5.5H69.2c-1.8,0-3.3,0-4.6-0.1c-1.3-0.1-2.5-0.3-3.7-0.9c-1.8-0.9-3.3-2.4-4.2-4.2 c-0.6-1.2-0.8-2.4-0.9-3.7c-0.1-1.2-0.1-2.8-0.1-4.6V2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.8,5.9c-0.4-0.1-0.8-0.1-2.6-0.1H24.4c-2,0-3.3,0-4.3,0.1c-1,0.1-1.4,0.2-1.7,0.4c-0.8,0.4-1.4,1-1.8,1.8 c-0.1,0.3-0.3,0.7-0.4,1.7c-0.1,1-0.1,2.3-0.1,4.3v67.4c0,2,0,3.3,0.1,4.3c0.1,1,0.2,1.4,0.4,1.7c0.4,0.8,1,1.4,1.8,1.8 c0.3,0.1,0.7,0.3,1.7,0.4c1,0.1,2.3,0.1,4.3,0.1h40c1.5,0,2.7,1.2,2.7,2.7c0,1.5-1.2,2.7-2.7,2.7H24.3c-1.8,0-3.3,0-4.6-0.1 c-1.3-0.1-2.5-0.3-3.7-0.9c-1.8-0.9-3.3-2.4-4.2-4.2c-0.6-1.2-0.8-2.4-0.9-3.7c-0.1-1.2-0.1-2.8-0.1-4.6V13.9c0-1.8,0-3.3,0.1-4.6 C11,8,11.2,6.7,11.8,5.6c0.9-1.8,2.4-3.3,4.2-4.2c1.2-0.6,2.4-0.8,3.7-0.9c1.2-0.1,2.8-0.1,4.6-0.1h30.9c0.1,0,0.2,0,0.3,0 c1.4,0,2.5,0,3.6,0.3c1,0.2,1.9,0.6,2.7,1.1c1,0.6,1.8,1.4,2.8,2.3c0.1,0.1,0.1,0.1,0.2,0.2l13.5,13.2c0.1,0.1,0.1,0.1,0.2,0.2 c1,1,1.9,1.8,2.5,2.8c0.5,0.9,0.9,1.8,1.2,2.8c0.3,1.1,0.3,2.3,0.3,3.7v0.3v30.3c0,1.5-1.2,2.7-2.7,2.7c-1.5,0-2.7-1.2-2.7-2.7 V27.2c0-1.8,0-2.3-0.1-2.7c-0.1-0.4-0.3-0.8-0.5-1.2c-0.2-0.4-0.5-0.7-1.8-2L60.9,8.2c-1.3-1.2-1.6-1.5-1.9-1.8 C58.6,6.2,58.2,6,57.8,5.9L57.8,5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.2,66.9c-4.6,0-8.2,3.7-8.2,8.2c0,4.6,3.7,8.2,8.2,8.2c2.3,0,4.3-0.9,5.8-2.4c1.5-1.5,2.4-3.6,2.4-5.9 C82.5,70.6,78.8,66.9,74.2,66.9z M60.5,75.2c0-7.6,6.1-13.7,13.7-13.7c7.6,0,13.7,6.1,13.7,13.7c0,2.8-0.9,5.4-2.3,7.6l4.6,4.6 c1.1,1.1,1.1,2.8,0,3.9c-1.1,1.1-2.8,1.1-3.9,0l-4.6-4.7c-2.2,1.4-4.7,2.2-7.5,2.2C66.6,88.9,60.5,82.7,60.5,75.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditIcon);
export default __webpack_public_path__ + "static/media/audit-icon.c1f556abecbee1481a1035ba83533f86.svg";
export { ForwardRef as ReactComponent };